import { Cubby } from "../Cubby";

// Internal Function: Calculate Total Liquidity Sum
const _calculateLiquiditySum = (cubby: Cubby): number => {
  if (!cubby.hasOpenChannels || !cubby.channelsList?.data) {
    return 0;
  }

  return cubby.channelsList.data
    .filter(
      (channel) => channel.synthetic_status === "open" && channel.is_active
    )
    .reduce(
      (total, channel) =>
        total + Math.max(0, channel.local_balance - channel.local_reserve),
      0
    );
};

// Function: Calculate Outbound Channel Choices
export const outBoundChannelChoices = (
  cubby: Cubby,
  proposedAmount: number
) => {
  const possibleChannels = cubby.channelsList?.data.filter(
    (channel) =>
      channel.synthetic_status === "open" &&
      channel.is_active &&
      channel.local_balance - channel.local_reserve > proposedAmount
  );

  if (possibleChannels && possibleChannels.length > 1) {
    return possibleChannels.map((channel) => ({
      alias: channel.alias,
      local_balance: channel.local_balance,
      scid: channel.scid,
    }));
  } else {
    return [];
  }
};

// Function: Calculate Outbound Liquidity
export const outBoundLiquidity = (cubby: Cubby): number => {
  const liquiditySum = _calculateLiquiditySum(cubby);
  return calcSafeAmountGivenPossibleFees(liquiditySum);
};

// Function: Calculate Total Reserves
export const totalReserves = (cubby: Cubby): number => {
  const liquiditySum = _calculateLiquiditySum(cubby);
  const safeAmount = calcSafeAmountGivenPossibleFees(liquiditySum);
  console.log("safeAmount", safeAmount);

  if (!cubby.hasOpenChannels || !cubby.channelsList?.data) {
    return 0;
  }

  // Calculate the sum of local_reserve for all open and active channels
  const sumLocalReserve = cubby.channelsList.data
    .filter(
      (channel) => channel.synthetic_status === "open" && channel.is_active
    )
    .reduce((total, channel) => total + channel.local_reserve, 0);

  // Total reserves include both the withheld liquidity and the local reserves
  return liquiditySum - safeAmount + sumLocalReserve;
};

// Helper Function: Calculate Safe Amount After Possible Fees
const calcSafeAmountGivenPossibleFees = (liquiditySum: number): number => {
  if (liquiditySum < 100) {
    // If the liquidity sum is less than 100 sats, subtract 5.
    return Math.max(0, Math.floor(liquiditySum - 5));
  } else {
    // If the liquidity sum is 100 or more, subtract the greater of:
    // 1) 5
    // 2) 0.5% times the liquidity sum
    const deduction = Math.max(5, Math.floor(0.005 * liquiditySum));
    return Math.max(0, Math.floor(liquiditySum - deduction));
  }
};
